import {
  CAR_CHOICE_ACCEPTED,
  CAR_CHOICE_ACCEPTED_WITH_REPRICE,
} from 'lib/carChoicesLib'
import {
  CARS_BOOKED_STATE_ASSIGNED,
  CARS_BOOKED_STATE_NOT_ASSIGNED,
} from 'lib/carsBookedStates'

export const CARS_BOOKED_ROOT = 'cars-booked'

export const CARS_BOOKED_CAR_DETAILS = 'car-details'

export const getCarsBookedUrl = (sessionId, partnerId, plate) => {
  const plateValue = plate ? `/${CARS_BOOKED_CAR_DETAILS}/${plate}` : ''

  return !sessionId || !partnerId
    ? `/${CARS_BOOKED_ROOT}`
    : `/${CARS_BOOKED_ROOT}/${sessionId}/${partnerId}${plateValue}`
}

export const getCarsBookedStatusColor = (status) =>
  [CARS_BOOKED_STATE_NOT_ASSIGNED].includes(status) ? 'error' : 'text.success'

export const getCarsBookedRecapValues = (cars, isSessionClosed) => {
  const result = cars.reduce(
    (previous, car) => ({
      acceptedChoice:
        (previous.acceptedChoice || 0) +
        (car.choice === CAR_CHOICE_ACCEPTED ? 1 : 0),
      acceptedWithRepriceChoice:
        (previous.acceptedWithRepriceChoice || 0) +
        (car.choice === CAR_CHOICE_ACCEPTED_WITH_REPRICE ? 1 : 0),
      assigned:
        (previous.assigned || 0) +
        (car.assignedState === CARS_BOOKED_STATE_ASSIGNED ? 1 : 0),
      notAssigned:
        (previous.notAssigned || 0) +
        (car.assignedState === CARS_BOOKED_STATE_NOT_ASSIGNED ? 1 : 0),
      totalValue:
        (isSessionClosed
          ? (car.inventoryPrice || 0) + (car.inventoryFee || 0)
          : car.choice === CAR_CHOICE_ACCEPTED_WITH_REPRICE
          ? car.reprice
          : car.price + car.fee) + previous.totalValue,
    }),
    { totalValue: 0 }
  )
  result.total = cars.length

  return result
}
